<template> 
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Financial Proposal</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col cols="6" class="text-right">
          <base-button type="primary" icon size="sm" @click="close()">
          <span class="btn-inner--text">Back / Close</span>
        </base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body class="mx-6">
          <customer-information></customer-information>
          <cash-flow-statement @cash-flow-statement-data="getCashFlowStatementData"></cash-flow-statement>
          <net-worth-statement @net-worth-statement-data="getNetWorthStatementData" :net_flow="cashFlowStatement.actual_net_flow" input_saving_info_from_user="true"></net-worth-statement>
          <!-- <net-worth-statement-v1></net-worth-statement-v1> -->
          <b-col class="text-center">
              <base-button type="primary" :disabled="isDisabled" ref="generatePDFButton" icon size="sm" @click.prevent="generatePDF()">{{button.text}}</base-button>
          </b-col>
          <br>
      </b-card>
    </b-container>
  </div>
</template>
<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
  import CustomerInformation from "@/views/FinancialProposal/CustomerInformation";
  import CashFlowStatement from "@/views/FinancialProposal/CashFlowStatement";
  import NetWorthStatement from "@/views/FinancialProposal/NetWorthStatement";
  import NetWorthStatementV1 from "@/views/FinancialProposal/demo/NetWorthStatementV1";
  import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js';
  import { apiGatewayDomain, getHeader} from '@/assets/js/config.js';
  import axios from 'axios';
  import html2canvas from 'html2canvas';
  import swal from 'sweetalert2';

  export default {
    mixins: [notifyFunctionMixin],
    components: {
      CustomerInformation,
      CashFlowStatement,
      NetWorthStatement,
      NetWorthStatementV1,
      RouteBreadCrumb,
    },
    data() {
      return {
        customers: [],
        cashFlowStatement: [],
        netWorthStatement: [],
        tableData: [],
        chartImage: null,
        isDisabled: false,
        button: {
          text: "Generate PDF"
        }
      };
    },
    created() {
      const customerInfo = {
        customer_id: this.$route.params.customer_id,
        financial_proposal_id: this.$route.params.financial_proposal_id,
      };
      window.localStorage.setItem('customerInfo', JSON.stringify(customerInfo));
      this.getCustomerEligibilityData();
      axios.get(apiGatewayDomain + 'financial_proposal/financial_proposal/' + this.$route.params.financial_proposal_id ,{ headers: getHeader() })
      .then ( response => {
          if (response.status === 200)
          {
            this.customers = response.data.data[0]
          }
      })
      .catch ( error => {
          console.log(error.response.status)
          this.errorFunction(error, "Show Customer")
      });
    },
    methods: {
      close() {
        // console.log(document.hidden);
        // if(!document.hidden)
        // {
        //   window.history.back();
        //   window.close();
        // }
        // else
        // {
        //   this.$router.back();
        // }

        if(this.$route.params.token)
        {
          window.history.back();
          window.close();
        }
        else
        {
          this.$router.back();
        }
      },
      getCashFlowStatementData(value)
      {
        this.cashFlowStatement = value;
      },
      getNetWorthStatementData(value)
      {
        this.netWorthStatement = value;
      },
      getCustomerEligibilityData() {
        axios.get(apiGatewayDomain + 'financial_proposal/get_customer_loan_eligibility_from_im2u/' + this.$route.params.customer_id ,{ headers: getHeader() })
        .then ( response => {
            if (response.status === 200)
            {
                this.tableData = response.data.data;
            }
        })
        .catch ( error => {
            console.log(error.response.status)
            this.errorFunction(error, "Show Customer Bank Eligibility")
        });
      },
      generatePDF() {
        console.log(this.tableData);
        console.log(this.netWorthStatement);
        if(this.tableData.length > 0 && this.netWorthStatement.selectedBank.length == 0)
        {
          swal.fire({
            title: 'Are you sure?',
            text: "Bank to provide loan to customer not selected!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
          }).then((result) => {
            if(result.isConfirmed)
            {
              this.generatingPDF();
            }
            else
            {
              this.isDisabled = false;
              this.button.text = "Generate PDF";
            }
          });
        }
        else
        {
          this.generatingPDF();
        }
      },
      async generatingPDF() {
        this.$notify({
            message: '<b>Generating Customer Financial Proposal Report.<br>This may takes a few seconds.<br>When finished, the pdf report will be downloaded automatically.',
            timeout: 10000,
            icon: 'ni ni-bell-55',
            type: 'default',
        });

        if(Object.keys(this.netWorthStatement.liabilities).length > 0)
        {
          // post the image to API
          await html2canvas(document.querySelector("#capture"), {
            onclone: function (clonedDoc) {
              clonedDoc.getElementById('capture').style.display = 'block';
            }
          }).then(canvas => {
            this.chartImage = canvas.toDataURL("image/jpeg");
            console.log('finish capture chart image');
          });
        }
        
        const postData = {
          customer_id: this.$route.params.customer_id,
          financial_proposal_id: this.$route.params.financial_proposal_id,
          image: this.chartImage,
          // Save Report Data
          customer_name: this.customers.customer_name,
          im2u_id: this.customers.im2u_customer_id,
          agent_name: this.customers.agent_name,
        };

        axios.post(apiGatewayDomain + 'financial_proposal/financial_proposal_report', postData ,{ responseType: 'blob', headers: getHeader() })
        .then ( response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', this.customers.customer_name+' '+this.customers.created_at+'.pdf');
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$notify({
            message:
                '<b>Financial Proposal Report for <b>'+this.customers.customer_name+'</b> Successfully Generated.',
            timeout: 10000,
            icon: 'ni ni-bell-55',
            type: 'success',
          });
          this.isDisabled = false;
          this.button.text = "Generate PDF";
        })
        .catch ( error => {
            // console.log(error.response.status)
            this.errorFunction(error, "Download PDF")
        });
      }
    }
  };
</script>
  